/* Marka landing sayfası.
   1) Koleksiyon açıklamasındaki tabloyu kaydırılabilir kabuğa alır.
   2) Mobilde uzun metinleri kısaltır ("Devamını oku") — telefonda sayfa düz
      yazı duvarına dönüşmesin, ürün şeritleri ekrana yakın kalsın.
   3) Yapışkan "içindekiler" çubuğunu sayfadaki bölümlerden kurar: her bölüm
      kendi id'si + data-mk-nav="Etiket" ile bildirir, bar DOM sırasına göre
      dolar. Bölüm ekleyip çıkardıkça çubuk kendiliğinden güncellenir.
      Çubuk artık ayrı bir bölüm ("Marka — İçindekiler"), sayfanın herhangi bir
      yerinde olabilir.
   4) Çubuğu header'ın GERÇEK alt kenarına oturtur ve aktif bölümü işaretler. */
(function () {
  'use strict';
  var MT = window.PETIDI_T || {};   // çeviri (theme.liquid; Türkçede boş → varsayılan)

  /* Birden fazla bölüm bu dosyayı yükleyebilir; bir kez çalışsın */
  if (window.__markaInit) return;
  window.__markaInit = true;

  /* ---------- 1. Açıklamadaki tablo ---------- */
  document.querySelectorAll('.mk__about table').forEach(function (table) {
    var parent = table.parentNode;
    if (!parent || (parent.classList && parent.classList.contains('mk__tblwrap'))) return;
    var wrap = document.createElement('div');
    wrap.className = 'mk__tblwrap';
    parent.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  /* ---------- 2. Mobilde uzun metinleri kısalt ----------
     Kısaltmayı JS yapıyor: script çalışmazsa metin tam haliyle kalsın.
     Yükseklik sınırı CSS'te ve yalnız mobil genişlikte geçerli. */
  var mkMobile = window.matchMedia('(max-width: 749px)');

  function clampText(el) {
    if (el.dataset.mkClip === '1' || !el.textContent.trim()) return;
    el.dataset.mkClip = '1';

    var open = false;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mk__more';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = MT.devamini_oku || 'Devamını oku';
    btn.hidden = true;
    el.parentNode.insertBefore(btn, el.nextSibling);

    btn.addEventListener('click', function () {
      open = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? (MT.daha_az_goster || 'Daha az göster') : (MT.devamini_oku || 'Devamını oku');
      evaluate();
    });

    /* Kırpma sınıfı yalnız GERÇEKTEN taşan metinde kalıyor: solma maskesi
       taşma olmasa da uygulanıp kısa paragrafın altını soldurur. */
    function evaluate() {
      if (!mkMobile.matches || open) {
        el.classList.remove('mk__clip');
        btn.hidden = !open || !mkMobile.matches;
        return;
      }
      el.classList.add('mk__clip');
      var over = el.scrollHeight > el.clientHeight + 4;
      if (!over) el.classList.remove('mk__clip');
      btn.hidden = !over;
    }

    evaluate();
    window.addEventListener('resize', evaluate);
    window.addEventListener('load', evaluate);
  }

  document.querySelectorAll('.mk .mk__text, .mk .mk__lead, .mk .mk__about').forEach(clampText);

  /* ---------- 3. İçindekiler çubuğunu kur ---------- */
  var bar = document.querySelector('[data-mk-navbar]');
  var spy = bar && bar.querySelector('[data-mk-spy]');
  if (!bar || !spy) return;

  var targets = Array.prototype.slice.call(document.querySelectorAll('[data-mk-nav]'))
    .filter(function (el) { return el.id && el.getAttribute('data-mk-nav').trim(); });

  /* Çubuk görünür basılıyor (CLS için yer ayrılı) — tek bölümde gereksiz, gizle */
  if (targets.length < 2) { bar.hidden = true; return; }

  var ph = spy.querySelector('[data-mk-navph]');
  if (ph) ph.remove();

  var links = targets.map(function (el) {
    var a = document.createElement('a');
    a.href = '#' + el.id;
    a.textContent = el.getAttribute('data-mk-nav');
    spy.appendChild(a);
    return a;
  });
  bar.hidden = false;

  /* ---------- 4. Konum + aktif bölüm ----------
     Bölümler ayrı ayrı olduğu için position:sticky yetmiyor (yapışkan öğe kendi
     bölümünün kutusunu geçemez). Çubuk header'ın alt kenarına gelince fixed'e
     alınıyor, yerine aynı yükseklikte boşluk konuyor. */
  var header = document.querySelector('.header');
  var spacer = document.createElement('div');
  spacer.className = 'mk__navspace';
  bar.parentNode.insertBefore(spacer, bar);

  var barH = 0;
  function syncTop() {
    var hb = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    var fixed = bar.classList.contains('is-fixed');
    if (!fixed) barH = Math.round(bar.getBoundingClientRect().height);

    var shouldFix = Math.round(spacer.getBoundingClientRect().top) <= hb;
    if (shouldFix !== fixed) {
      bar.classList.toggle('is-fixed', shouldFix);
      spacer.style.height = shouldFix ? barH + 'px' : '0px';
    }
    bar.style.top = shouldFix ? hb + 'px' : '';
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { syncTop(); ticking = false; });
  }

  syncTop();
  window.addEventListener('resize', syncTop);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', syncTop);
  if (header && 'ResizeObserver' in window) new ResizeObserver(syncTop).observe(header);

  function offset() {
    return (header ? header.getBoundingClientRect().height : 0) + (barH || bar.getBoundingClientRect().height) + 8;
  }

  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset(), behavior: 'smooth' });
    });
  });

  /* Çubuk mobilde yatay kayıyor; aktif bölüm sağda kalıp görünmez olmasın */
  var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fade() {
    bar.classList.toggle('has-more', spy.scrollLeft + spy.clientWidth < spy.scrollWidth - 2);
    bar.classList.toggle('has-prev', spy.scrollLeft > 2);
  }

  function reveal(a) {
    if (spy.scrollWidth <= spy.clientWidth) return;
    var wr = spy.getBoundingClientRect();
    var ar = a.getBoundingClientRect();
    var pad = 42; /* kenardaki solma bandından (34px) geniş olsun ki aktif düğme altında kalmasın */
    var delta = 0;
    if (ar.left < wr.left + pad) delta = ar.left - wr.left - pad;
    else if (ar.right > wr.right - pad) delta = ar.right - wr.right + pad;
    if (delta) spy.scrollTo({ left: spy.scrollLeft + delta, behavior: smooth ? 'smooth' : 'auto' });
  }

  spy.addEventListener('scroll', fade, { passive: true });
  window.addEventListener('resize', fade);
  fade();

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var active = null;
        links.forEach(function (a) {
          var on = a.getAttribute('href') === '#' + entry.target.id;
          a.classList.toggle('is-on', on);
          if (on) active = a;
        });
        if (active) reveal(active);
      });
    },
    { rootMargin: '-45% 0px -50% 0px' }
  );

  targets.forEach(function (t) { io.observe(t); });
})();
